export const environment = {
  api_server: 'https://gigantix-api.talentosoftware.com',
  front_url: 'https://gigantix.talentosoftware.com',
  api_endpoints: {
    auths: '/auths',
    centers: '/centers',
    centers_delete: '/centers/delete',
    extendToken: '/login/expiration',
    login: '/login',
    match: '/matches/:id',
    matches: '/phases/:id/matches',
    matchPieces: '/matches/:id/change-pieces',
    passwordChange: '/login/password',
    passwordChangeOtherUser: '/user/:id/change-password',
    passwordRecovery: '/login/forgotten',
    players: '/players',
    playersDelete: '/players/:id/delete',
    publicGroups: '/public/tournament/:id/groups',
    publicMatches: '/public/tournament/:id/matches',
    publicRounds: '/public/tournament/:id/rounds',
    publicStandings: '/public/tournament/:id/standings',
    roundsFinished: '/tournaments/:type/:tournament/check-rounds-finished',
    teams: '/teams',
    teamsDelete: '/teams/:id/delete',
    tournaments: '/tournaments/:type',
    tournamentsDelete: '/tournaments/:type/:id/delete',
    tournamentGroups: '/groups/tournament/:tournament',
    tournamentGroupsCreate: '/tournaments/:type/:tournament/generate-groups',
    tournamentPlayoffs: '/phases/tournament/:tournament/playoffs',
    tournamentPlayoffsCreate: '/tournaments/:type/:tournament/generate-playoffs',
    tournamentRounds: '/phases/tournament/:tournament/rounds',
    tournamentRoundsCreate: '/tournaments/:type/:tournament/generate-rounds',
    tournamentStandings: '/tournaments/:type/:tournament/standings/rounds',
    tournamentStandingsPositions: '/tournaments/:type/standings/positions',
    tournamentTeams: '/tournaments/:type/:tournament/teams',
  },
  log: {
    debug: true,
    error: true,
    info: true,
    warn: true,
  },
  production: false,
  public_path: {
    groups: '/public/groups/',
    rounds: '/public/rounds/',
    standings: '/public/standings/',
  },
  teamsMin: 20,
};
